<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><b>Contents</b></span></p>
<p class="toc-entry"><span><a href="#/xhtml/part01"><i>May</i></a></span></p>
<p class="toc-entry"><span><span href="#/xhtml/part02" title="Link target outside of Sample"><i>June</i></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/part03" title="Link target outside of Sample"><i>July</i></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/part04" title="Link target outside of Sample"><i>August</i></span></span></p>
<p class="toc-entry1"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?cfe753b4